<template>
  <div class="top-header">
    <Navbar style="z-index: 5" />
    <div id="app" class="app">
      <div class="main-content">
        <div class="header">
          <Header />
        </div>
        <div id="introduction">
          <Solutions />
        </div>
        <div id="features" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="1000">
          <Features />
        </div>
        <div id="deploy" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="1000">
          <Deploy />
        </div>
        <div id="technology" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="1000">
          <Technology />
        </div>
        <div id="contact" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-duration="1000">
          <Booking />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from '../components/Navbar';
import Header from '../components/Header';
import Solutions from '../components/Solutions';
import Features from '../components/Features';
import Deploy from '../components/Deploy';
import Technology from '../components/Technology';
import Booking from '../components/Booking';

export default {
  name: 'App',
  components: {
    Navbar,
    Header,
    Solutions,
    Features,
    Deploy,
    Technology,
    Booking
  }
}
</script>
